// Horarios de registro de asistencia (diferenciados por roles)

import React, { useState } from 'react';
import { useUser } from '../UserContext';
import RegisterAttendanceForEmployee from '../components/RegisterAttendanceForEmployee';
import RegisterAttendance from '../components/RegisterAttendance';
import RegisterOfficeAttendance from '../components/RegisterOfficeAttendance';
import { Box, Typography } from '@mui/material';

export default function SchedulesRegisterAttendance() {
  const { user, hasRole } = useUser();

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Asistencias</Typography>
      </Box>
      {hasRole(['ADMIN', 'SUPERVISOR', 'HR_ADMIN']) && (
        <RegisterAttendance />
      )}
      {hasRole(['ADMIN', 'SUPERVISOR', 'HR_ADMIN']) && (
        <RegisterOfficeAttendance />
      )}
      {hasRole(['EMPLOYEE', 'HR_ADMIN']) && (
        <RegisterAttendanceForEmployee />
      )}
    </section>
  );
}